export enum Tab {
  Favourite = 0,
  Purchases = 1,
  Recommends = 2,
}
